import { history } from "@ers/helpers";
import { formatErrorMessage } from ".";

class RequestError extends Error {
	constructor(error, url) {
		let message = "";
		let status;
		if (error.response) {
			// The request was made and the server responded with a status
			// outside the allowed set.
			message = `Request error occured.
            Data:
            ${error.response.data}
            Status:
            ${error.response.status}
            Headers:
            ${error.response.headers}`;
			status = error.response.status;
			history.goToError(status);
		} else if (error.request) {
			// The request was made but no response was received.
			message = error.request;
		} else {
			message = error.message;
		}
		super(...formatErrorMessage(message));
		Error.captureStackTrace(this, RequestError);
		this.message = message;
		this.status = status;
		this.url = url;
		history.goToError(status);
	}
}

export default RequestError;
